import React, { useEffect, useState } from "react";
import Template from "../utils/Template";
import Card from "../utils/Card";
import TableScroll from "../utils/TableScroll";
import { Table, TableBody, TableHeader } from "../utils/Table";
import { getMethod, postMethod } from "../service";
import {
  decodeData,
  errorToaster,
  formatDate,
  successToaster,
} from "../utils/Helper";
import { useNavigate } from "react-router-dom";
import { CASH_OUTS_API, CASH_OUTS_CONFIRM_API } from "../service/constant";
import Pagination from "../utils/Pagination";
import Input from "../utils/Input";
import DateRangeFormat from "../utils/DateRangeFormat";
import SubmitBtn from "../utils/SubmitBtn";
import { useSelector } from "react-redux";

const Withdraws = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [from, setFrom] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [cashOuts, setCashOuts] = useState([]);
  const [refs, setRefs] = useState(false);
  const [searchId, setSearchId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const navigate = useNavigate();
  const { refresh } = useSelector((state) => state.refresh);

  const fetchCashOuts = async () => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      try {
        const res = await getMethod(
          `${CASH_OUTS_API}?page=${page}&limit=50&start_date=${startDate}&end_date=${endDate}&search=${searchId}`,
          token.token
        );
        if (res?.isSuccess) {
          setCashOuts(res.data);
          setFrom((res.meta?.current_page - 1) * 50);
          setTotalPage(res.meta?.last_page);
        } else {
          errorToaster("Failed to fetch cash-outs");
        }
      } catch (error) {
        console.error("Error fetching cash-outs:", error);
        errorToaster("An error occurred while fetching cash-outs");
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
      errorToaster("Unauthenticated!");
      setTimeout(() => {
        navigate("/login");
      }, 100);
    }
  };

  const handleConfirm = async (cashoutId) => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      try {
        const res = await postMethod(
          `${CASH_OUTS_CONFIRM_API}`,
          { state: "approve", cashout_id: cashoutId },
          token.token
        );
        if (res?.isSuccess) {
          successToaster("Cash-out approved successfully.");
          fetchCashOuts();
        } else {
          errorToaster(res?.message || "Failed to approve cash-out");
        }
      } catch (error) {
        console.error("Error confirming cash-out:", error);
        errorToaster("An error occurred while approving cash-out");
      }
      setIsLoading(false);
    }
  };

  const handleReject = async (cashoutId) => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      try {
        const res = await postMethod(
          `${CASH_OUTS_CONFIRM_API}`,
          { state: "reject", cashout_id: cashoutId },
          token.token
        );
        if (res?.isSuccess) {
          successToaster("Cash-out rejected successfully.");
          fetchCashOuts();
        } else {
          errorToaster(res?.message || "Failed to reject cash-out");
        }
      } catch (error) {
        console.error("Error rejecting cash-out:", error);
        errorToaster("An error occurred while rejecting cash-out");
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCashOuts();
  }, [refs, page, refresh]);

  return (
    <Template title={"Withdraws"} isLoading={isLoading}>
      <Card>
        <div className="row d-flex justify-content-end">
          <div className="col-12 col-md-4 px-1">
            <Input
              type="text"
              value={searchId}
              event={(e) => setSearchId(e.target.value)}
              placeholder="Search User Name OR Phone"
            />
          </div>

          <div className="col-12 col-md-4 px-1 mb-3">
            <DateRangeFormat
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
          <div className="col-12 col-md-4 px-1 mb-3">
            <SubmitBtn
              type="submit"
              name="Search"
              event={() => setRefs(!refs)}
              isLoading={isLoading}
            />
          </div>
        </div>
        <TableScroll>
          <Table>
            <TableHeader>
              <th>No.</th>
              <th>User Name</th>
              <th>Phone</th>
              <th>Amount</th>
              <th>Bank Type</th>
              <th>Bank Acc Name</th>
              <th>Bank Acc No.</th>
              <th>Action</th>
              <th>Date & Time</th>
            </TableHeader>
            <TableBody>
              {cashOuts.length > 0 &&
                cashOuts.map((cashOut, i) => (
                  <tr key={cashOut._id} style={{ verticalAlign: "middle" }}>
                    <td>{i + 1}</td>
                    <td>{cashOut?.userId.name}</td>
                    <td>{cashOut?.userId.phone}</td>
                    <td className="text-end">
                      {cashOut?.amount?.toLocaleString("en-us")}
                    </td>
                    <td>{cashOut?.payment_provider_id?.bank_type}</td>
                    <td>{cashOut?.accountName}</td>
                    <td>{cashOut?.accountNumber}</td>
                    <td>
                      {cashOut?.state === "pending" && (
                        <>
                          <button
                            className="btn btn-success py-1"
                            onClick={() => handleConfirm(cashOut._id)}
                          >
                            Approve
                          </button>
                          <button
                            className="btn btn-danger ms-2 py-1"
                            onClick={() => handleReject(cashOut._id)}
                          >
                            Reject
                          </button>
                        </>
                      )}

                      {cashOut?.state === "approve" && (
                        <span className="badge bg-success">Approved</span>
                      )}

                      {cashOut?.state === "reject" && (
                        <span className="badge bg-danger">Rejected</span>
                      )}
                    </td>
                    <td>{formatDate(cashOut?.createdAt)}</td>
                  </tr>
                ))}
            </TableBody>
          </Table>
        </TableScroll>
        {totalPage > 1 && (
          <div className="d-flex justify-content-end">
            <Pagination
              setPage={setPage}
              setIsLoading={setIsLoading}
              totalPage={totalPage}
            />
          </div>
        )}
      </Card>
    </Template>
  );
};

export default Withdraws;
